<div class="logo-wrapper">
    <a [routerLink]="['/site_summary']">
        <img class="img-fluid" src="assets/images/logo/logo.png" alt="">
    </a>
    <img src="assets/images/logo/Bulbs.png" alt="" class="img-fluid Sidebarbulb">
    <i class="fa fa-angle-left close-sidebar" (click)="openMenu()"></i>
</div>
<div class="logo-icon-wrapper">
    <a [routerLink]="['/site_summary']">
        <img class="img-fluid" src="assets/images/logo-icon.png" alt="">
    </a>
</div>
<nav class="sidebar-main">
    <div class="left-arrow" id="left-arrow" [class.d-none]="leftArrowNone" (click)="scrollToLeft()">
        <app-feathericon [icon]="'arrow-left'"></app-feathericon>
    </div>
    <ul>
        <li *ngIf="logintype === 'AA'|| logintype === 'DEV' || logintype ==='C'" class="sidebar-main-title" style="padding: 3px 0px 0px 13px;margin-bottom:2px">
            <div class="selectLocation" style="width: 95%;">
                <div class="btn-group" ngbDropdown [autoClose]="true" style="height:40px;width: 100%;">
                    <button class="btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100" style="border: none;" type="button" ngbDropdownToggle>
                        <span style="color: white;">{{ selectedSite?.site_name || 'Select Site' }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu style="min-width: 267px;max-width: 267px; max-height: 300px;overflow: hidden;margin-left: 10px !important;">
                        <li class="px-1 py-1 sticky-top bg-white search-container">
                            <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon" style="position: absolute;left: 10px; top: 9px;">
                            <input type="text" class="form-control form-control-sm searchbar" placeholder="Search" [ngModel]="searchTerm" (ngModelChange)="search$.next($event)">
                            <button *ngIf="add_Edit" class="btn addbtn" [routerLink]="'/addsites'">Add Site</button>
                        </li>
                        <li>
                            <hr class="dropdown-divider mt-1 mb-0">
                        </li>
                        <cdk-virtual-scroll-viewport appendOnly itemSize="22" style="height: 250px; width: 100%;">
                            <li class="list" *cdkVirtualFor="let item of filteredItems; trackBy: trackBySiteId" [class.active]="item.site_id === selectedSite?.site_id">
                                <a class="dropdown-item d-flex align-items-center px-2 py-1 text-wrap flex-grow-1" href="javascript:void(0)" (click)="selectSite(item)" style="word-wrap: break-word;">
                                    <button *ngIf="item.site_name!=='All Sites' && add_Edit" class="btn btn-outline btn-sm editsite" (click)="goToEditSite($event, item.site_id)">
                                        <svg style="margin: 0; height:12px;width:12px" width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.6556 3.43923L8.56079 1.34485C8.49114 1.27519 8.40845 1.21993 8.31745 1.18223C8.22644 1.14453 8.1289 1.12512 8.0304 1.12512C7.93189 1.12512 7.83435 1.14453 7.74334 1.21993 7.65234 1.27519 7.56965 1.34485 7.50001 1.34485L1.71985 7.12501C1.6499 7.1944 1.59444 7.277 1.5567 7.36802C1.51896 7.45903 1.49969 7.55664 1.5 7.65517V9.75001C1.5 9.94892 1.57902 10.1397 1.71967 10.2803C1.86033 10.421 2.05109 10.5 2.25 10.5H10.125C10.2245 10.5 10.3198 10.4605 10.3902 10.3902C10.4605 10.3198 10.5 10.2245 10.5 10.125C10.5 10.0256 10.4605 9.93017 10.3902 9.85984C10.3198 9.78952 10.2245 9.75001 10.125 9.75001H5.40563L10.6556 4.50001C10.7253 4.43036 10.7806 4.34768 10.8183 4.25667C10.856 4.16566 10.8754 4.06812 10.8754 3.96962C10.8754 3.87111 10.856 3.77357 10.8183 3.68257C10.7806 3.59156 10.7253 3.50887 10.6556 3.43923ZM4.34485 9.75001H2.25V7.65517L6.37501 3.53016L8.46985 5.62501L4.34485 9.75001ZM9.00001 5.09485L6.90563 3.00001L8.03063 1.87501L10.125 3.96985L9.00001 5.09485Z"
                                            fill="#DB1E49" />
                                        </svg>
                                    </button>
                                    {{SitenameProvide(item.site_id,item.site_name,item.short_code)}}
                                </a>
                            </li>
                        </cdk-virtual-scroll-viewport>

                        <li *ngIf="shouldShowNoSitesFound()" class="px-3 py-2 text-muted text-center">No sites found.</li>
                        <li *ngIf="shouldShowNoSitesAvailable()" class="px-3 py-2 text-muted text-center">No sites available.</li>
                    </ul>
                </div>
            </div>

        </li>
    </ul>
    <div id="sidebar-menu" [ngStyle]="{ marginLeft: this.layout.config.settings.sidebar_type == 'horizontal-wrapper' ? margin + 'px' : '0px' }">
        <ul *ngIf="!sidebarLoading" class="sidebar-links theme-scrollbar d-flex flex-column" id="simple-bar">
            <li class="back-btn">
                <a href="javascript:void(0)">
                    <img class="img-fluid" src="assets/images/logo/logo-icon.png" alt="">
                </a>
                <div class="mobile-back text-end">
                    <span>Back</span>
                    <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
                </div>
            </li>
            <li class="pin-title sidebar-main-title" [class.show]="pined">
                <div>
                    <h6>Pinned</h6>
                </div>
            </li>

            <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: menuItems }"></ng-container>
            <ng-template #recursiveMenu let-menuItems>
                <li class="sidebar-main-title" style="padding: 3px 0px 0px 13px;margin-bottom: -6px;">
                </li>
                @for(item of menuItems; track item){
                <li [ngClass]="{
                    'sidebar-list': item.level == 1,
                    'sidebar-main-title': item.headTitle1,
                    'sidebar-animated': !item.headTitle1 
                }" [ngStyle]="{
                    'animation-delay': item.id * 100 + 'ms'
                }" [class.pined]="isPined(item.id)" [ngbTooltip]="item.headTitle1 ? (item.headTitle1 | translate) : (item.title | translate)" placement="right" container="body" triggers="hover">
                    @if(item.headTitle1){
                    <div>
                        <h6>{{item.headTitle1| translate}}</h6>
                    </div>
                    } @if(item.level == 1){
                    <i class="fa fa-thumb-tack" (click)="togglePined(item.id)"></i> } @if(item.type === 'extTabLink'){
                    <a [ngbTooltip]="item.title" href="{{ !item.type ? null : item.path }}">
                                        {{ item.title | translate }}
                                    </a> } @else{ @if(!item.headTitle1){
                    <a [ngClass]="{
                                        'sidebar-link sidebar-title': item.level == 1,
                                        'submenu-title': item.level == 2,
                                        'actived': item.active && item.level === 1
                                    }" [routerLink]="(item.children?.length ? null : item.path?.route)" [queryParams]="(item.path?.route && siteId && siteId !== 'QUxM' && siteid === 'Y' && (logintype === 'AA' || logintype === 'DEV' || logintype ==='C'))
                                        ? { siteid: encodedId }
                                        : null" (click)="toggleMenu(item)" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                                    @if(item.icon && item.level == 1){
                                        <app-svg-icon [icon]="item.icon"></app-svg-icon>
                                    }

                                    @if(item.level == 1){
                                        <span style="margin-left: 10px;">{{ item.title | translate }}</span>
                                    } @else {
                                        {{ item.title | translate }}
                                    }

                                    <div class="according-menu">
                                        @if(item.children && item.children.length > 0){
                                        <i class="fa fa-angle-{{ item.active ? 'down' : 'right' }} pull-right"></i>
                                        }
                                    </div>
                                    </a> } } @if(item.children && item.children.length > 0){
                    <ul [ngClass]="{ 'sidebar-submenu': item.level == 1, 'nav-sub-childmenu submenu-content' : item.level == 2 }" [style.display]="item.active  ? 'block' : 'none'">
                        <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: item.children }"></ng-container>
                    </ul>
                    }
                </li>
                }
            </ng-template>
        </ul>
        <!-- SHIMMER SIDEBAR -->
        <ul *ngIf="sidebarLoading" class="sidebar-links theme-scrollbar d-flex flex-column xn-shimmer-list">
            <li *ngFor="let _ of [].constructor(6)" class="d-flex align-items-center gap-2 xn-shimmer-item mb-2 ml-2">
                <div class="xn-shimmer-text"></div>
            </li>
        </ul>

        <div class="right-arrow" id="right-arrow" [class.d-none]="rightArrowNone" (click)="scrollToRight()">
            <app-feathericon [icon]="'arrow-right'"></app-feathericon>
        </div>
    </div>
</nav>